var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const TableHeader = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("thead", Object.assign({ className: clsx('bg-surface-50', className) }, rest), children));
};
export const TableHeaderCell = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("th", Object.assign({ scope: "col", className: clsx('px-6 py-3 text-left font-medium text-basicSurface-500 tracking-wider', className) }, rest), children));
};
//# sourceMappingURL=TableHeader.js.map